import { useEffect, useState } from "react";
import { Link } from "react-router";
import { istInstalliert, istIos } from "../push";
import s from "./shell.module.css";

interface InstallEreignis extends Event {
  prompt: () => Promise<void>;
}

const SCHLUESSEL = "obsn.installHinweisWeg";
function lesen(k: string): string | null {
  try {
    return window.localStorage.getItem(k);
  } catch {
    return null;
  }
}
function schreiben(k: string, v: string): void {
  try {
    window.localStorage.setItem(k, v);
  } catch {
    /* privates Fenster: Hinweis kommt beim nächsten Mal wieder */
  }
}

/** Hinweisbanner zur Installation (Phase 6). iPhone: Anleitung, weil Push nur in der installierten App geht. Android: Knopf „Installieren“. */
export function InstallHinweis() {
  const [weg, setWeg] = useState(() => lesen(SCHLUESSEL) === "1" || istInstalliert());
  const [ereignis, setEreignis] = useState<InstallEreignis | null>(null);
  useEffect(() => {
    const f = (e: Event) => {
      e.preventDefault();
      setEreignis(e as InstallEreignis);
    };
    window.addEventListener("beforeinstallprompt", f);
    return () => window.removeEventListener("beforeinstallprompt", f);
  }, []);
  if (weg || (!istIos() && !ereignis)) return null;
  const schliessen = () => {
    schreiben(SCHLUESSEL, "1");
    setWeg(true);
  };
  return (
    <div className={s.installHinweis} role="region" aria-label="App installieren">
      <p>
        {istIos() ? (
          <>
            Tipp: Füge die obsn App über „Teilen“ und „Zum Home-Bildschirm“ hinzu und melde dich dort an. Nur dann geht Push. <Link to="/profil#push">So geht’s</Link>
          </>
        ) : (
          "Installier die obsn App auf diesem Gerät. Dann startet sie wie eine App und Push geht."
        )}
      </p>
      <span className={s.installKnoepfe}>
        {ereignis ? (
          <button
            type="button"
            onClick={() => {
              void ereignis.prompt().finally(() => setEreignis(null));
            }}
          >
            Installieren
          </button>
        ) : null}
        <button type="button" onClick={schliessen} aria-label="Installationshinweis schließen">
          ×
        </button>
      </span>
    </div>
  );
}
